"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (epoch) {
    return new Date(epoch * 1000);
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/epochToDate.js
// module id = 2
// module chunks = 0